var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"ods-menu-item-group"},[_c('div',{staticClass:"ods-menu-item-group__title",style:({paddingLeft: _vm.levelPadding + 'px'})},[(!_vm.$slots.title)?[_vm._v(_vm._s(_vm.title))]:_vm._t("title")],2),_c('ul',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }